import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/pages/login'], resolve),
    },
    {
      path: '/wx_login',
      name: 'wx_login',
      component: resolve => require(['@/pages/login/wxLogin'], resolve),
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/pages/register'], resolve),
    },
    {
      path: '/dynamic_index',//财粮说
      name: 'dynamic_index',
      component: resolve => require(['@/pages/dynamic'], resolve),
      children: [
        {
          path: '/dynamic_recommend',//首页
          name: 'dynamic_recommend',
          component: resolve => require(['@/pages/dynamic/homeDynamic/index'], resolve),
          children: [{
            path: '/dynamic_recommend',//推荐
            name: 'dynamic_recommend',
            component: resolve => require(['@/pages/dynamic/homeDynamic/recommend'], resolve),
          }, {
            path: '/dynamic_subscribe',//订阅
            name: 'dynamic_subscribe',
            component: resolve => require(['@/pages/dynamic/homeDynamic/subscribe'], resolve),
          }]
        },
        {
          path: '/my_dynamic',//我的
          name: 'my_dynamic',
          component: resolve => require(['@/pages/dynamic/myDynamic'], resolve),
          children: [{
            path: '/my_dynamic',//我的动态
            name: 'my_dynamic',
            component: resolve => require(['@/pages/dynamic/myDynamic/myNews'], resolve),
          }, {
            path: '/my_collection',//我的收藏
            name: 'my_collection',
            component: resolve => require(['@/pages/dynamic/myDynamic/collection'], resolve),
          }, {
            path: '/my_draft',//我的草稿
            name: 'my_draft',
            component: resolve => require(['@/pages/dynamic/myDynamic/myDraft'], resolve),
          },]
        }, {
          path: '/editPersonal',//编辑个人资料
          name: 'editPersonal',
          component: resolve => require(['@/pages/dynamic/myDynamic/editPersonal'], resolve),
        },
      ]
    },
    {
      path: '/quotation',
      name: 'quotation',
      component: resolve => require(['@/pages/dynamic/homeDynamic/quotation'], resolve),
    },
    {
      path: '/quotation_details',
      name: 'quotation_details',
      component: resolve => require(['@/pages/dynamic/homeDynamic/details'], resolve),
    },
    {
      path: '**',   // 错误路由[写在最后一个]
      redirect: '/login'   //重定向
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js